<template>
	<!-- 打卡日历页面 -->
	<div class='all'>
		<div class="bar">
			<!-- 上一个月 -->
			<div class="previous" @click="handleCalendar(0)">	
				<!-- <img class="barbtn" src="/static/image/arrow-left-ico.png" mode=""></img> -->
				<van-icon size="1.5rem" name="arrow-left" color="#1989fa"/>
			</div>
			<!-- 显示年月 -->
			<div class="date">{{cur_year || "--"}} 年 {{cur_month || "--"}} 月</div>
			<!-- 下一个月 -->
			<div class="next" @click="handleCalendar(1)">
				<!-- <img class="barbtn" src="/static/image/arrow-left-ico.png" mode=""></img> -->
				<van-icon size="1.5rem" name="arrow" color="#1989fa"/>
			</div>
		</div>
		
		<!-- 显示星期 -->
		<div class="week">
			<div v-for="(item,index) in weeks_ch" :key="index">{{item}}</div>
		</div>

		<div  class="myDateTable">
			<div v-for="(item,j) in days" :key="j" class='dateCell'>
				<div v-if="item.date == undefined || item.date == null" class='cell'>
					<span :decode="true">&nbsp;&nbsp;</span>
				</div>
				
				<div v-else>
					<!-- 已签到日期 -->
					<div v-if="item.isSign == true" class='cell'>
						<!-- <img class="cell-img" src="/static/image/agree-ico.png" mode=""></img> -->
						<!-- <van-icon size="2rem" name="passed" color="#ee0a24"/> -->
						<div class="onSign">{{item.date}}</div>
					</div>	
					<!-- 当前日期之后 -->
					<div class="blackColor cell" v-else>
						<span>{{item.date}}</span>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				days: [],
				SignUp: [],
				cur_year: 0, //当前选的年
				cur_month: 0, //当前选的月
				today: parseInt(new Date().getDate()), //本日
				toMonth: parseInt(new Date().getMonth() + 1), //本月
				toYear: parseInt(new Date().getFullYear()), //本年
				weeks_ch: ['日', '一', '二', '三', '四', '五', '六']
			};
		},
		props: {
			sendYear: {
				type: Number,
				default: new Date().getFullYear()
			},
			sendMonth: {
				type: Number,
				default: new Date().getMonth() + 1
			},
			dataSource: { //已签到的数据源
				type: Array,
				default: () => {
					return []
				}
			}
		},
		created() {
			this.cur_year = this.sendYear;
			this.cur_month = this.sendMonth;
			this.SignUp = this.dataSource;
			this.calculateEmptyGrids(this.cur_year, this.cur_month);
			this.calculateDays(this.cur_year, this.cur_month);
			this.onJudgeSign();
		},
		watch: {
			dataSource: 'onResChange',
		},
		methods: {
			// 获取每个月有多少天
			getThisMonthDays(year, month) {
				return new Date(year, month, 0).getDate()
			},
			
			// 获取当月第一天星期几
			getFirstDayOfWeek(year, month) {
				return new Date(year, month - 1, 1).getDay();
			},
			
			// 计算当月1号前空了几个格子，把它填充在days数组的前面
			calculateEmptyGrids(year, month) {
				//计算每个月时要清零
				this.days = [];
				
				const firstDayOfWeek = this.getFirstDayOfWeek(year, month);
				
				if (firstDayOfWeek > 0) {
					for (let i = 0; i < firstDayOfWeek; i++) {
						var obj = {
							date: null,
							isSign: false
						};
						
						this.days.push(obj);
					}
				}
			},

			// 绘制当月天数占的格子，并把它放到days数组中
			calculateDays(year, month) {
				const thisMonthDays = this.getThisMonthDays(year, month);
				
				for (let i = 1; i <= thisMonthDays; i++) {
					var obj = {
						date: i,
						isSign: false
					};
					
					this.days.push(obj);
				}
			},
             
			onResChange(newD, oldD) {
				this.SignUp = newD;
				this.onJudgeSign();
			},
			
			//匹配判断当月与当月哪些日子签到打卡
			onJudgeSign() {
				var signs = this.SignUp;
				var daysArr = this.days;
				
				for (var i = 0; i < signs.length; i++) {
					for (var j = 0; j < daysArr.length; j++) {
						//年月日相同则打卡成功   						
						if (daysArr[j].date == signs[i].day) { 
							daysArr[j].isSign = true;
							daysArr[j].num = signs[i].num;
						}
					}
				};
				
				this.days = daysArr;
			},

			// 切换控制年月，上一个月，下一个月
			handleCalendar(type) {
				const cur_year = parseInt(this.cur_year);
				const cur_month = parseInt(this.cur_month);
				
				var newMonth;
				var newYear = cur_year;
				
				if (type === 0) {  // 上个月
					newMonth = cur_month - 1;
					if (newMonth < 1) {
						newYear = cur_year - 1;
						newMonth = 12;
					}
				} else {
					newMonth = cur_month + 1;
					if (newMonth > 12) {
						newYear = cur_year + 1;
						newMonth = 1;
					}
				};
				
				this.calculateEmptyGrids(newYear, newMonth);
				this.calculateDays(newYear, newMonth);

				this.cur_year = newYear;
				this.cur_month = newMonth;

				this.SignUp = []; //先清空
				this.$emit('dateChange', this.cur_year+"-"+this.cur_month); //传给调用模板页面去拿新数据				
			}
		}
	}
</script>

<style lang="less" scoped>
	.all {
		margin-top: 0.625rem;
		background-color: #FFFFFF;
		border-radius: 0.3125rem;
		.bar {
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin: 0.9375rem 0.625rem;
			padding: 0.3125rem 1.71875rem;
			padding-top: 1rem;
			.next {
				.barbtn {
					transform: rotate(180deg);
				}
			}
			.barbtn {
				width: 0.53125rem;
				height: 1rem;
			}
			.date {
				font-size:1.0625rem;
				font-weight:bold;
				color:rgba(20,104,255,1);
				line-height:1rem;
			}
			
		}
		
		.week {
			display: flex;
			padding: 0.625rem 1.25rem;
			margin: 0 0.625rem;
			// border-radius: 0.3125rem;
			background-color: #fff;
			border-bottom: 0.0625rem solid #DBDBDB;
			div {
				width: 14.2%;
				text-align: center;
				color: #333333;
			}
		}
	    
		.myDateTable {
			margin: 2.5vw;
			padding: 0 1.25rem;
			display: flex;
			flex-wrap: wrap;
			border-radius: 0.3125rem;
			background: #FFFFFF;
			
			.dateCell {
				width: 14.2%;
				font-size: 1rem;
				
				.cell {
						display: flex;
						border-radius: 50%;
						height: 11vw;
						justify-content: center;
						align-items: center;
						.cell-img {
							width: 1.40625rem;
							height: 1.40625rem;
						}
					}
			}
		}
	}

	.whiteColor {
		color: #fff;
	}
	
	.blackColor {
		color: #333333;
	}

	.bgBlue {
		font-size: 0.875rem;
		background-color: #4b95e6;
	}
	
	.TipArea{
		word-break:break-all;
		word-wrap:break-word;
		
		font-size: 0.875rem;
		padding: 0.625rem;
	}
	
	.impTip{
		display: inline-block;
		color: #ff0000;
	}
	.onSign{
		background-color:#eb3223;
		width: 2rem;
		height: 2rem;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 100px;
		color: #FFFFFF;
		font-size: 0.8rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/calendar/calendar/calendar.vue